import { useCreateMediaVariantSync } from 'hooks/queries/mediaFiles/useCreateMediaVariant'
import { IMediaFile } from '../UploadsTab/Types'
import { MediaTransformations } from 'types'
import { isEqual, uniqWith } from 'lodash'
import { insertImage } from '../UploadsTab/insertImage'
import { Editor } from '@tldraw/tldraw'

/**
 * Return a function to insert a media file into the editor, creating a variant if necessary.
 * If a variant fails to be created, the original media file is inserted
 * instead.
 */
export const useInsertMediaFile = () => {
  const createMediaVariant = useCreateMediaVariantSync()

  return async (
    editor: Editor,
    {
      mediaFile,
      transformations,
    }: {
      mediaFile: IMediaFile
      transformations: MediaTransformations
    },
    options?: { replaceReplaceable?: boolean },
  ) => {
    if (isEqual(transformations, {})) {
      await insertImage(editor, mediaFile, options)
      return
    }

    try {
      const variant = await createMediaVariant.mutateAsync({ mediaFileId: mediaFile.id, transformations })
      const fileWithVariant = {
        ...mediaFile,
        variants: uniqWith([variant, ...(mediaFile.variants || [])], (a, b) =>
          isEqual(a.transformations, b.transformations),
        ),
      }
      await insertImage(editor, fileWithVariant, {
        removeBackground: Boolean(transformations.remove_background),
        ...options,
      })
    } catch (e) {
      await insertImage(editor, mediaFile, options)
    }
  }
}
